import React, { FC, useState } from 'react';
import { Flex, Menu, MenuButton, MenuItem, MenuList, Progress, Radio, RadioGroup, Spacer, Stack, Text } from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';
import { BsThreeDots } from 'react-icons/bs';
interface Props {
  poll: Poll;
  selectedAnswer: (pollAnswer: ID | null) => void;
}

const PollComponent: FC<Props> = ({ poll, selectedAnswer }) => {
  const [value, setValue] = useState('-1');
  const isVotedByInvestor = poll.answers.some(answer => answer.isVotedByInvestor === true);
  const { t } = useTranslation();

  return (<>
    <Flex mb={'30px'}>
      <Text fontSize="18px" fontWeight="normal">{poll.question}</Text>
      <Spacer/>
      {isVotedByInvestor && (<Menu isLazy>
        <MenuButton><BsThreeDots size={21} color="grey" /></MenuButton>
        <MenuList>
          <MenuItem background="white" onClick={() => {
            selectedAnswer(null);
          }}>{t('declineVote')}</MenuItem>
        </MenuList>
      </Menu>)}
    </Flex>
    <Text fontSize="14px" mb={'16px'} fontWeight="medium">{t('anonymousPoll')}</Text>
      {!isVotedByInvestor && (<RadioGroup onChange={setValue} value={value}>
        <Stack direction="column" spacing="37px" h="full">
        {poll.answers.map((answer, index) => (
          <Stack direction="row" key={index} w="full" h="full" alignItems="start" alignSelf="start">
            <Radio value={index.toString()} key={index}
                   onClick={event => {
                     selectedAnswer(answer.id);
                   }}
                   size="lg"
                   mr="15px"
                   w="40px"
                   colorScheme="green">
            </Radio>
            <Text w="full" fontSize="16px">{answer.text}</Text>
          </Stack>
        ))}
      </Stack></RadioGroup>)}
      {isVotedByInvestor && (<Stack direction="column" spacing="23px">
        {poll.answers.map((answer, index) => (
          <Stack direction="row" key={index} h="full">
            <Stack direction="column" alignItems="end" mr="15px" w="40px">
              <Text>{((answer.voteCount ?? 0) / (poll.totalVotes ?? 1) * 100)}%</Text>
              {answer.isVotedByInvestor && (<CheckCircleIcon color="whatsapp.500" />)}
            </Stack>
            <Stack direction="column" w="full">
              <Text fontSize="16px">{answer.text}</Text>
              <Progress isAnimated={true} value={((answer.voteCount ?? 0) / (poll.totalVotes ?? 1) * 100)} h="7px" borderRadius="16" colorScheme="whatsapp" w="full" background="transparent" onClick={event => { console.log(poll.answers); }}/>
            </Stack>
          </Stack>
        ))}
      </Stack>)}</>);
};

export default PollComponent;
